/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React from "react";
import { Table } from "react-materialize";
import Html from "../../utils/Html";

import SummaryHead from "./summary.head";
import SummaryRows from "./summary.rows";
import SelectPage from "./main.content.select.page";

export default function SummaryTab({
  userData,
  filters,
  setFilters,
  data,
  loading }) {
  // data รูปแบบที่คาดหวังจาก MainContent.fetchData():
  // {
  //   expired_date: "",
  //   requests: [],
  //   requests_total: number,
  //   total_page: number,
  //   active_page: number
  // }

  const requests = data?.data || [];
  const requestsTotal =
    typeof data?.summary_total === "number"
      ? data.summary_total
      : requests.length || 0;
  const totalPage = data?.total_page || 0;
  const activePage = data?.active_page || 1;
  const expiredDate = data?.expired_date || "";

  return (
    <div id="table-content">
      {!loading && (
        <div id="table-total">
          Total : <span id="table-total__number">{requestsTotal}</span>
        </div>
      )}

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "32px 0 24px",
            minHeight: 80 }}
        >
          <Html.Preloading
            addon={{
              css: { position: "static", margin: 0, transform: "none" } }}
          />
        </div>
      ) : (
        <>
          <Table className="highlight table-leave" id="table-leave-summary">
            <thead>
              <SummaryHead expiredDate={expiredDate} />
            </thead>
            <tbody>
              <SummaryRows rows={requests} />
            </tbody>
          </Table>

          <SelectPage
            totalPage={totalPage}
            activePage={activePage}
            setFilters={setFilters}
            // เดิมเคย setReqData ในแท็บนี้เพื่อเก็บผล fetch;
            // ตอนนี้ให้ parent fetch แทน จึงไม่ต้องเซ็ตที่นี่
            setReqData={() => {}}
          />
        </>
      )}
    </div>
  );
}

